import dayjs from 'dayjs';

export const convertFilterValueToDTO = (filter, ignoreCaseSensitive) => {
	const value = filter.value === null ? undefined : filter.value;

	switch (filter.column.filterType) {
		case FilterType.string:
			return {
				key: [filter.column.accessor],
				ignoreCase: ignoreCaseSensitive,
				action: filter.action === FilterAction.multipleFilter ? FilterAction.is : filter.action,
				value: filter.action === FilterAction.multipleFilter ? value : [value]
			};
		case FilterType.number:
			return {
				key: [filter.column.accessor],
				ignoreCase: ignoreCaseSensitive,
				action:
					filter.action === FilterAction.greaterThan || filter.action === FilterAction.lessThan
						? FilterAction.between
						: filter.action === FilterAction.multipleFilter
							? FilterAction.is
							: filter.action,
				value:
					filter.action === FilterAction.greaterThan || filter.action === FilterAction.lessThan
						? undefined
						: filter.action === FilterAction.multipleFilter
							? value
							: [value],
				from: filter.action === FilterAction.greaterThan ? Number(value) : undefined,
				to: filter.action === FilterAction.lessThan ? Number(value) : undefined
			};
		case FilterType.float:
			return {
				key: [filter.column.accessor],
				ignoreCase: ignoreCaseSensitive,
				action: filter.action,
				from: value.min !== null && value.min !== undefined ? Number(value.min) : undefined,
				to: value.max !== null && value.max !== undefined ? Number(value.max) : undefined
			};
		case FilterType.date:
			return {
				key: [filter.column.accessor],
				ignoreCase: ignoreCaseSensitive,
				action:
					filter.action === FilterAction.after ||
					filter.action === FilterAction.before ||
					filter.action === FilterAction.on
						? FilterAction.between
						: filter.action === FilterAction.notEmpty
							? FilterAction.notNull
							: filter.action === FilterAction.isEmpty
								? FilterAction.isNull
								: filter.action,
				from:
					filter.action === FilterAction.after ||
					filter.action === FilterAction.between ||
					filter.action === FilterAction.on
						? value.start
						: undefined,
				to:
					filter.action === FilterAction.before
						? value.start
						: filter.action === FilterAction.between
							? value.end
							: filter.action === FilterAction.on
								? dayjs(value.start).add(1, 'day').toISOString()
								: undefined
			};
		case FilterType.selection:
		case FilterType.multiSelection:
		case FilterType.enum:
		case FilterType.enumMulti:
			return {
				key: [filter.column.accessor],
				ignoreCase: ignoreCaseSensitive,
				action: filter.action,
				value: Array.isArray(value) ? value : [value]
			};
		default:
			throw new Error('Unknown filter type');
	}
};

export const convertSortValueToDTO = (sortBy) => ({ key: [sortBy[0].id], order: sortBy[0].desc ? 'desc' : 'asc' });

export const FilterType = {
	string: 'string',
	number: 'number',
	float: 'float',
	date: 'date',
	selection: 'selection',
	multiSelection: 'multiSelection',
	enum: 'enum',
	enumMulti: 'enumMulti'
};

export const FilterAction = {
	is: 'is',
	isNot: 'isNot',
	contains: 'contains',
	startsWith: 'startsWith',
	greaterThan: 'greaterThan',
	lessThan: 'lessThan',
	isNull: 'isNull',
	isEmpty: 'isEmpty',
	notEmpty: 'notEmpty',
	notNull: 'notNull',
	multipleFilter: 'multipleFilter',
	on: 'on',
	after: 'after',
	before: 'before',
	between: 'between'
};

export const FilterInput = {
	string: 'string',
	number: 'number',
	float: 'float',
	selection: 'selection',
	enum: 'enum',
	date: 'date',
	chips: 'chips'
};

export const FilterConfig = {
	[FilterType.string]: [
		{
			action: FilterAction.startsWith,
			inputType: FilterInput.string
		},
		{
			action: FilterAction.contains,
			inputType: FilterInput.string
		},
		{
			action: FilterAction.is,
			inputType: FilterInput.string
		},
		{
			action: FilterAction.isNot,
			inputType: FilterInput.string
		},
		{
			action: FilterAction.isEmpty
		},
		{
			action: FilterAction.notEmpty
		},
		{
			action: FilterAction.multipleFilter,
			inputType: FilterInput.chips
		}
	],
	[FilterType.number]: [
		{
			action: FilterAction.is,
			inputType: FilterInput.number
		},
		{
			action: FilterAction.startsWith,
			inputType: FilterInput.number
		},
		{
			action: FilterAction.contains,
			inputType: FilterInput.number
		},
		{
			action: FilterAction.isNot,
			inputType: FilterInput.number
		},
		{
			action: FilterAction.greaterThan,
			inputType: FilterInput.number
		},
		{
			action: FilterAction.lessThan,
			inputType: FilterInput.number
		},
		{
			action: FilterAction.isEmpty
		},
		{
			action: FilterAction.notEmpty
		},
		{
			action: FilterAction.multipleFilter,
			inputType: FilterInput.chips
		}
	],
	[FilterType.float]: [
		{
			action: FilterAction.between,
			inputType: FilterInput.float
		},
		{
			action: FilterAction.isEmpty
		},
		{
			action: FilterAction.notEmpty
		}
	],
	[FilterType.selection]: [
		{
			action: FilterAction.is,
			inputType: FilterInput.selection
		},
		{
			action: FilterAction.isNot,
			inputType: FilterInput.selection
		},
		{
			action: FilterAction.isEmpty
		},
		{
			action: FilterAction.notEmpty
		}
	],
	[FilterType.multiSelection]: [
		{
			action: FilterAction.is,
			inputType: FilterInput.selection,
			multiple: true
		},
		{
			action: FilterAction.isNot,
			inputType: FilterInput.selection,
			multiple: true
		},
		{
			action: FilterAction.isEmpty
		},
		{
			action: FilterAction.notEmpty
		}
	],
	[FilterType.enum]: [
		{
			action: FilterAction.is,
			inputType: FilterInput.enum
		},
		{
			action: FilterAction.isNot,
			inputType: FilterInput.enum
		},
		{
			action: FilterAction.contains,
			inputType: FilterInput.enum
		},
		{
			action: FilterAction.isEmpty
		},
		{
			action: FilterAction.notEmpty
		}
	],
	[FilterType.enumMulti]: [
		{
			action: FilterAction.is,
			inputType: FilterInput.enum,
			multiple: true
		},
		{
			action: FilterAction.isNot,
			inputType: FilterInput.enum,
			multiple: true
		},
		{
			action: FilterAction.contains,
			inputType: FilterInput.enum,
			multiple: true
		},
		{
			action: FilterAction.isEmpty
		},
		{
			action: FilterAction.notEmpty
		}
	],
	[FilterType.date]: [
		{
			action: FilterAction.on,
			inputType: FilterInput.date
		},
		{
			action: FilterAction.after,
			inputType: FilterInput.date
		},
		{
			action: FilterAction.before,
			inputType: FilterInput.date
		},
		{
			action: FilterAction.between,
			inputType: FilterInput.date,
			rangeMode: true
		},
		{
			action: FilterAction.isEmpty
		},
		{
			action: FilterAction.notEmpty
		}
	]
};

export const DefaultFilterActionMap = {
	string: FilterAction.startsWith,
	number: FilterAction.is,
	float: FilterAction.between,
	date: FilterAction.on,
	selection: FilterAction.is,
	multiSelection: FilterAction.is,
	enum: FilterAction.is,
	enumMulti: FilterAction.is
};

export const ExportFilterTypes = {
	[FilterType.string]: 'String',
	[FilterType.number]: 'Number',
	[FilterType.date]: 'DateTime',
	[FilterType.float]: 'Number',
	[FilterType.selection]: 'Enum',
	[FilterType.multiSelection]: 'Enum',
	[FilterType.enum]: 'Enum',
	[FilterType.enumMulti]: 'Enum'
};

export const ListComponents = {
	STATUS: 'status',
	EXPORT_FILE_STATUS: 'exportFileStatus',
	IMPORT_FILE_STATUS: 'importFileStatus',
	DOWNLOAD_IMPORT_FILE_BUTTON: 'downloadImportFileButton',
	SHIPMENT_STATUS: 'shipmentStatus',
	OTO_ORDER_STATUS_HISTORY: 'otoOrderStatusHistory',
	OTO_LINK_SESSION_STATUS: 'otoLinkSessionStatus',
	WAREHOUSE_WORKING_STATUS: 'warehouseWorkingStatus',
	DATE: 'dateViewer',
	DATETIME: 'dateTimeViewer',
	DATE_TIME_WITH_SECONDS: 'dateTimeWithSecondsViewer',
	DATETIMEWITHOUTLOCALE: 'dateTimeWithoutLocaleViewer',
	EXPIRY_DATE: 'expiryDateViewer',
	TEXT_ARRAY: 'ArrayTextViewer',
	STRING_ARRAY: 'StringArrayViewer',
	PROFILE_IMAGE: 'profileImage',
	PRODUCT_IMAGE: 'productImage',
	BRAND_LOGO: 'brandLogo',
	DC_LOGO: 'dcLogo',
	DELIVERY_COMPANY_LOGO: 'DeliveryCompanyLogoViewer',
	SALES_CHANNEL_LOGO: 'salesChannelLogo',
	TRACKING_URL: 'trackingURL',
	LAST_COMMENT: 'lastComment',
	PHONE: 'phoneViewer',
	CARD: 'cardViewer',
	CURRENCY: 'currencyViewer',
	CURRENCY_COLORED: 'currencyViewerColored',
	CURRENCY_BOLD: 'currencyViewerBold',
	DOWNLOAD_INVOICE: 'downloadInvoice',
	COUNTRY: 'countryViewer',
	URL: 'urlViewer',
	DOWNLOAD_FILE: 'downloadFile',
	EXPORT_FILE_NAME: 'exportFileName',
	PERCENTAGE: 'percentageViewer',
	TRANSACTION_STATUS: 'transactionStatus',
	CHIP_VIEWER: 'chipViewer',
	CLIENT_AGREEMENT_TYPE: 'clientAgreementType',
	PICKUP_AND_DELIVERY_TYPE: 'pickupAndDeliveryType',
	CITY_TAGS: 'cityTags',
	DURATION: 'durationViewer',
	WEIGHT_UPDATE_INFORMATION: 'weightUpdateInformation'
};
